export default __webpack_public_path__ + "static/media/info_btn_icon1_white.3d5dbf19.svg";